module.exports = __webpack_public_path__ + "static/media/report.b587649c.svg";